"use server";

import { revalidatePath } from "next/cache";
import { getDb } from "@/lib/db/client";
import { requireRole } from "@/lib/auth/current-user";
import { findOrCreateUnitateEntry, setUnitateCount, adjustUnitateCount } from "@/lib/catalog/unitate";

/** Adds (or finds) the Unitate Școlară stock row for a MEN catalog entry; the caller navigates to the returned id. ADMIN only — viewing is open to all, editing isn't. */
export async function addToUnitateCatalog(catalogEntryId: string): Promise<{ id: string }> {
  const user = await requireRole("ADMIN");
  const result = await findOrCreateUnitateEntry(getDb(), catalogEntryId, user.id);
  revalidatePath("/evidenta/catalog-unitate");
  return { id: result.id };
}

/** Direct correction to an exact quantity — for initial entry or fixing a mistake, not day-to-day +/- adjustments. */
export async function setUnitateCountValue(unitateEntryId: string, count: number): Promise<void> {
  await requireRole("ADMIN");
  if (!Number.isInteger(count) || count < 0) {
    throw new Error("Cantitatea trebuie să fie un număr întreg, nenegativ.");
  }
  await setUnitateCount(getDb(), unitateEntryId, count);
  revalidatePath("/evidenta/catalog-unitate");
  revalidatePath(`/evidenta/catalog-unitate/${unitateEntryId}`);
}

/** +1 / -1 (or any delta) without the caller reading the current value first — see lib/catalog/unitate.ts. */
export async function adjustUnitateCountValue(unitateEntryId: string, delta: number): Promise<{ count: number }> {
  await requireRole("ADMIN");
  if (!Number.isInteger(delta)) {
    throw new Error("Valoare invalidă.");
  }
  const result = await adjustUnitateCount(getDb(), unitateEntryId, delta);
  revalidatePath("/evidenta/catalog-unitate");
  revalidatePath(`/evidenta/catalog-unitate/${unitateEntryId}`);
  return result;
}
